import IndustryActivity from "../../searchFlowVersionB/components/industryActivity/IndustryActivity.jsx";
import i18n from "../../../utils/i18n";

export {
  INDUSTRIES_WITH_ACTIVITY_CONTENT as KFTREG_INDUSTRIES_WITH_ACTIVITY_CONTENT,
  industryHasActivityContent as kftRegIndustryHasActivityContent,
  isIndustryActivityAnswered as isKftRegIndustryActivityAnswered,
} from "../../searchFlowVersionB/utils/industryActivity.js";

const KftRegIndustryActivity = () => (
  <IndustryActivity title={i18n.t("searchflow.regactivitytitle")} />
);

export default KftRegIndustryActivity;
